<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="$store.state.google_oauth2"
      class="elevation-1"      
      :search="search"
    >      
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="item in items" :key="item.email">
            <td class="text-xs-left">
              {{item.email}}
            </td>
            <td>
              <v-btn @click="remove(item.id)" title="Remover conta" fab dark small color="error">
                <v-icon dark>remove</v-icon>
              </v-btn>              
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {

  name: 'List',
  created () {
    this.$store.dispatch('fetchGOauth2');
  },
  methods: {
    remove(data) {
      if (confirm('Tem certeza que quer apagar?')) {
        this.$store.dispatch('deleteGOauth2', {params: {id: data}})
      }
    },
    edit(item) {      
      this.$emit('edit', item);
    },
  },
  data () {
    return {
      search: '',
      configureStore: false,
      configureDialog: false,
      successCopy: false,
      pubUrl: '',      
      headers: [
        {text: 'Email', value: 'email'},
        {text: '', value: ''}
      ],
    }
  }
}
</script>

<style lang="css" scoped>
input {
  min-width: 90%;
  display: block;
  margin: 0;
  padding: 0;
}
</style>